module.exports = __webpack_public_path__ + "img/meteorito04.f2dc3bf5.svg";